import currency from "./currency.filter";
import datetime from "./datetime.filter";
import date     from "./date.filter";
import rtp      from "./rtp.filter";
import rate     from "./rate.filter";
import tofixed  from "./tofixed.filter";
import tzoffset from "./tzoffset.filter";



// WEBPACK FOOTER //
// ./src/filters/_filters.js